<template>
    <div class="bg-white">
        <div class="animate__animated animate__fadeInRight" v-if="ready">
            <div id="countdown" class="text-white">
                <countdown :particle='true'/>
            </div>
            <div id="mempelai" class="text-white">
                <mempelai  :particle='true'/>
            </div>
            <div id="acara" class="text-white">
                <acara  :particle='true'/>
            </div>
            <div id="peta" class="text-white">
                <peta  :particle='true'/>
            </div>
            <div id="galery" class="text-white">
                <galery  :particle='true'/>
            </div>
            <div id="video" class="text-white">
                <videos  :particle='true'/>
            </div>
            <div id="comment" >
                <comment  :particle='true'/>
            </div>
             <div id="doa" class="text-white">
                <doa  :particle='true'/>
            </div>
             <div id="penutup" class="text-white">
                <penutup  :particle='true'/>
            </div>
             <!-- <div id="credit" class="text-white">
                <credit  />
            </div> -->
            <div id="musik" class="text-white">
                <musik />
            </div>
             
        </div>
        <div v-else>
            <p class="animated bounce infinite text-center">
                Loading
            </p>
        </div>
        <br>
        <br>
        <br>
        <br>
        <navigation1 />
    </div>
</template>
<script>
import autophp from '@/plugins/autophp';
let sdb = new autophp();
let urlnya="https://undangan.officialapp.website";
import countdown from '@/components/app_undangan/countdown.vue'
import mempelai from '@/components/app_undangan/mempelai.vue'
import acara from '@/components/app_undangan/acara.vue'
import peta from '@/components/app_undangan/peta.vue'
import galery from '@/components/app_undangan/galery.vue'
import videos from '@/components/app_undangan/video.vue'
import comment from '@/components/app_undangan/comment.vue'
import doa from '@/components/app_undangan/doa.vue'
import penutup from '@/components/app_undangan/penutup.vue'
import credit from '@/components/app_undangan/credit.vue'
import musik from '@/components/app_undangan/musik.vue'
import navigation1 from '@/components/app_undangan/navigation.vue'
export default{
    data(){
        return{
            undangan:[],
            ready:false
        }
    },
     components: {
        countdown,
        mempelai,
        acara,
        peta,
        galery,
        videos,
        comment,
        doa,
        penutup,
        credit,
        musik,
        navigation1,
    },
    mounted() {
        this.ready=true;
        // this.getUndangan();
        // this.getGalery();
        // this.getAcara();
    },
    methods: {
        getUndangan(){
        let that=this;
        sdb.collection("app_undangan_nikah",false,urlnya).doc().select(`select *,tb1.id as id from app_undangan_nikah tb1 left join app_undangan_nikah_mempelai tb2 on tb2.id=tb1.mempelai where tb1.id='${this.$route.query.id}'`).then(res => {
                that.$store.state.data.undangan=res[0]
                 sdb.collection("app_undangan_nikah_galery",false,urlnya).doc().select(`select * from app_undangan_nikah_galery where undangan='${that.$route.query.id}'`).then(res => {
                    that.$store.state.data.galery=res
                     sdb.collection("app_undangan_nikah_acara",false,urlnya).doc().select(`select * from app_undangan_nikah_acara where undangan='${that.$route.query.id}' order by id desc`).then(res => {
                        that.$store.state.data.acara=res
                        that.ready=true;
                        that.$forceUpdate();
                    });
                });
            });
        },
        getGalery(){
            // sdb.collection("app_undangan_nikah_galery",false,urlnya).doc().select(`select * from app_undangan_nikah_galery where undangan='${that.$route.query.id}'`).then(res => {
            //     this.$store.state.data.galery=res
            //     this.$forceUpdate();
            // });
        },
        getAcara(){
            sdb.collection("app_undangan_nikah_acara",false,urlnya).doc().select(`select * from app_undangan_nikah_acara where undangan='${this.$route.query.id}'`).then(res => {
                this.$store.state.data.acara=res
                this.$forceUpdate();
            });
        },
    },
}
</script>
